module.exports = __webpack_public_path__ + "static/media/3.575db822.jpg";